(function () {
	angular.module('ResearchKitApplicationModule').factory('shareService', ["$http", "ceUrl", function ($http, ceUrl) {
		var routePrefix = ceUrl.make("api/cfhrconnect/");

		var requestTypeParameterMap = {
			"share": ["Share"],
			"access": ["Access"],
			"accessAndShare": ["Access", "Share"]
		};

		var cancelRequest = function (request) {
			return $http.delete(routePrefix + "request/" + request.ID).then(function (response) {
				return response.data;
			});
		};

		var declineRequest = function (request) {
			return $http.put(routePrefix + "request/" + request.ID + "/decline").then(function (response) {
				return response.data;
			});
		};

		var approveRequest = function (request) {
			return $http.put(routePrefix + "request/" + request.ID + "/approve").then(function (response) {
				return response.data;
			});
		};

		var revokeAccess = function (relationshipID) {
			return $http.delete(routePrefix + "accessrights/" + relationshipID).then(function (response) {
				return response.data;
			});
		};

		var getNetwork = function () {
			return $http.get(routePrefix + "network/").then(function (response) {
				return response.data;
			});
		};

		var sendRequest = function (email, requestType) {
			return $http.post(routePrefix + "request/", {
				TargetEmail: email,
				Types: requestTypeParameterMap[requestType]
			}).then(function (response) {
				return response.data;
			});
		};

		return {
			cancelRequest: cancelRequest,
			declineRequest: declineRequest,
			approveRequest: approveRequest,
			revokeAccess: revokeAccess,
			getNetwork: getNetwork,
			sendRequest: sendRequest
		};
	}]);
})();
